import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type {
  CollectionCreateInput,
  CollectionUpdateInput,
} from "@/modules/collections/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import { useCreateCollection } from "../api/queries";
import { CollectionFormTour, useCollectionFormTour } from "../tour";
import { CollectionForm } from "../ui/CollectionForm";

export function CollectionCreatePage() {
  const nav = useNavigate({ from: "/app/catalog/collections/new" });
  const createCollection = useCreateCollection();
  const { run, handleJoyrideCallback, startTour } = useCollectionFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຄໍເລັກຊັນ", to: "/app/catalog/collections" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງ Collection{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ເພີ່ມ Collection ໃໝ່ ຊື່ 3 ພາສາ, Slug, ລຳດັບການສະແດງ.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/catalog/collections" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="mt-6 rounded-xl border bg-card p-6">
          <CollectionForm
            onSubmit={async (
              values: CollectionCreateInput | CollectionUpdateInput,
            ) => {
              await createCollection.mutateAsync(
                values as CollectionCreateInput,
              );
              nav({ to: "/app/catalog/collections" } as any);
            }}
            onCancel={() => nav({ to: "/app/catalog/collections" } as any)}
            submitting={createCollection.isPending}
            onDevFill={isDevMode ? () => {} : undefined}
          />
        </div>
        <CollectionFormTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
